module.exports = __webpack_public_path__ + "static/media/img1-tc-mobile.038ab6ab.png";